<template>
    <div class="searchManage" transition="search-manage">
        <div id="searchManage">
            <top-search :searchtype="searchtype" :keyword.sync="keyword"></top-search>
            <div class="hotSearchWord" v-if="searchHotWord.length>0">
                <h3>热门搜索</h3>
                <ul>
                    <li v-for="value in searchHotWord" @click="search(value.searchWord)">{{value.searchWord}}</li>
                </ul>
            </div>
            <div class="searchRecord" v-if="searchRecord.length>0">
                <h3>历史搜索</h3>
                <ul>
                    <li v-for="value in searchRecord" @click="search(value.searchContent)">{{value.searchContent}}</li>
                </ul>
                <div class="clearRecord" @click="clearSearch()">清除搜索记录</div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
    @import "SearchManager.less";
</style>
<script>
    module.exports = {
        name : 'search-manage',
        data: function () {
            return {
                searchHotWord: [],
                searchRecord: [],
                searchtype: 'searchManage'
            }
        },
        props:["keyword"],
        created: function () {
            this.$http.jsonp('getSearchHotWord').then(function (response) {
                this.searchHotWord = response.data.respData;
            });
            this.$http.jsonp('getSearchRecord').then(function (response) {
                this.searchRecord = response.data.respData;
                //对后端接口获取的数据进行解码
                this.searchRecord.forEach(function(value){
                       value.searchContent = decodeURIComponent(value.searchContent.replace(/%(25)+/g,'%'));
                })
            });
        },
        methods: {
            search: function (message) {
                if (message.trim().length > 0) {
                    message = decodeURIComponent(message.replace(/%(25)+/g,''));
                    this.$router.go({name:'search',params:{keyword:message}});
                }
            },
            clearSearch: function () {
                if (confirm('确定要清除吗？')) {
                    this.$http.jsonp('clearSearchRecord').then(function (response) {
                        if (response.data.respCode == 0) {
                            this.searchRecord = [];
                        }
                    });
                }

            }
        },
        components: {
            'top-search': require('../TopSearch/TopSearch.vue')
        },
        ready:function(){
            //console.log(this.$els.searchblur.textContent);
        }

    }
</script>


/** WEBPACK FOOTER **
 ** SearchManager.vue?26cc0a0a
 **/